$ ->
  return if $('[data-color-match]').length < 1
  $window = $(window)

  isColorInRange = (base, sample) ->
    THRESHOLD = 40
    i = 0
    while i < 3
      if base[i] - THRESHOLD > sample[i] or base[i] + THRESHOLD < sample[i]
        return false
      i++
    true

  sampleCanvasColor = (video, c, bg, guide) ->
    ctx = c.getContext('2d')
    ctx.drawImage video, 0, 0
    p = ctx.getImageData(0, 0, 1, 1).data
    if isColorInRange(guide, p)
      bg.style.backgroundColor = "rgb(#{p[0]},#{p[1]},#{p[2]})"
    return

  drawingLoop = (v, c) ->
    if !v.paused
      window.requestAnimationFrame () ->
        drawingLoop v, c

    c.height = v.clientHeight;
    c.width = v.clientWidth;

    ctx = c.getContext('2d')
    ctx.drawImage v, 0, 0, v.videoWidth, v.videoHeight, 0, 0, v.offsetWidth, v.offsetHeight
    return

  needsCanvas = (video) ->
    videoId = $(video).attr('id')
    $("canvas[data-video='#{videoId}']").length < 1

  getCanvas = (video) ->
    videoId = $(video).attr('id')
    $("canvas[data-video='#{videoId}']")

  createCanvas = (video) ->
    if not needsCanvas(video)
      return getCanvas(video)

    $video = $(video)
    $('<canvas />')
      .addClass $video.data('canvas-classes')
      .attr 'data-video', $video.attr('id')
      .insertBefore $video

  pauseOnResize = (video, resizeTimer) ->
    $window.on 'resize.colorSwatch', (e) ->
      video.pause() if !video.paused
      clearTimeout resizeTimer
      resizeTimer = setTimeout((->
        video.play() if video.paused
        return
      ), 250)
    return

  videoColorMatch = (i, bg) ->
    resizeTimer = undefined
    video = document.getElementById $(bg).data('color-match')
    guide = $(bg).data('color-guide')
    canvas = false
    return if not video

    video.addEventListener 'canplaythrough', ( =>
      canvas = createCanvas(video).get(0)
      sampleCanvasColor(video, canvas, bg, guide)
      pauseOnResize(video, resizeTimer)
      setTimeout (->
        canvas.width = 720
        canvas.height = 720
        video.pause()
        video.play()
        return
      ), 25
      $(video).addClass('tdd--canvas-loaded')
      return
    ), { once: true }

    video.addEventListener 'play', ( =>
      drawingLoop(video, canvas) if canvas
    ), false

    video.pause()
    video.play()


  colorMatchVideos = () ->
    $('[data-color-match]').each videoColorMatch
    return

  $(document).on 'ready', colorMatchVideos
